/**
 * The live plan stream (docs/plans/change-planner.md §6): the generated client's `planStream`
 * (a WebSocket with the session's token in its subprotocol), the token refreshed first (a 401 on
 * the handshake cannot be retried), reconnected two seconds after it closes until `close()`.
 */
import { client, ensureFreshToken } from './api';
import type { plans } from './client';

const RECONNECT_DELAY_MS = 2_000;

export function openPlanStream(handshake: plans.PlanStreamHandshake, onMessage: (message: plans.PlanStreamMessage) => void): () => void {
  let closed = false;
  let current: { close(): void } | null = null;
  let timer: ReturnType<typeof setTimeout> | undefined;

  const connect = async (): Promise<void> => {
    if (closed) return;
    try {
      await ensureFreshToken();
      const stream = await client.plans.planStream(handshake);
      current = stream;
      for await (const message of stream) {
        if (closed) break;
        onMessage(message);
      }
    } catch {
      // the reconnect below covers a failed handshake
    }
    current = null;
    if (!closed) timer = setTimeout(() => void connect(), RECONNECT_DELAY_MS);
  };
  void connect();

  return () => {
    closed = true;
    if (timer !== undefined) clearTimeout(timer);
    current?.close();
  };
}
